import { GetLocationDemandData } from 'helpers/api-calls/role-calls';
import { demandPlannerOperations } from './duck';

const fetchDemandData = (locationId) => (dispatch) => {
  dispatch(demandPlannerOperations.loadDemandData());

  return GetLocationDemandData(locationId)
    .then((response) => {
      // Check if the response structure is different
      const demandData = response.data.demand_data || response.data.demands || response.data;
      dispatch(demandPlannerOperations.loadDemandDataSuccess(demandData));
    })
    .catch((error) => {
      console.error('Error fetching demand data:', error);
      dispatch(demandPlannerOperations.loadDemandDataError(error));
    });
};

export const demandPlannerOperationsExtended = {
  ...demandPlannerOperations,
  fetchDemandData,
}; 